export enum SurveyType {
  ProfileSurvey = 1,
  DynamicProfile = 3,
  External = 4,
  Intermediate = 5
}
